<template>
<div>
  <div class="section start-section desc-1" id="aggregator-sect">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 col-12">
          <div class="row">
            <div class="col-12">
              <h3 class="title">
                Casino <span class="font-bold">Aggregator</span>
              </h3>
            </div>
            <div class="col-12">
              <span class="sub-text mb-lg-0 mb-5"
                >The Ear Ltd offers a wide range of casino games and products by
                all the leading providers across the market. Our fantastic
                aggregator solution will let you manage the entire marketing
                strategy, games, and promotions across all/ individual providers
                with a single web application, avoiding you to deal with every
                provider's tool. It's easy to use, and its cross-device
                compatibility gives it unique flexibility and excellent user
                experience. Moreover, with our APIs, you will be able to
                integrate the games in your already existing platform!</span
              >
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-12 pl-lg-5">
          <img
            class="img-fluid genie-img"
            :src="this.publicPath+'assets/img/pngs/genie.png'"
            alt="the ear igaming platform"
            title="Casino aggregator"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="section section-bro-card desc-1">
    <div class="container">
      <div class="row multiple-items" data-aos="fade">
        <div class="col col-card">
          <div class="bro-card">Realtime GGR Dashboard</div>
        </div>
        <div class="col col-card">
          <div class="bro-card">Analytics with custom queries</div>
        </div>
        <div class="col col-card">
          <div class="bro-card">Campaign tools</div>
        </div>
        <div class="col col-card">
          <div class="bro-card">Bonus system</div>
        </div>
        <div class="col col-card">
          <div class="bro-card">3rd party invoice predictions</div>
        </div>
        <div class="col col-card">
          <div class="bro-card">game reports</div>
        </div>
        <div class="col col-card">
          <div class="bro-card">Omni-channel</div>
        </div>
        <div class="col col-card">
          <div class="bro-card">multi brand</div>
        </div>
      </div>
    </div>
  </div>

  <div class="section desc-1 aggregator-branded-container" id="branded-sect">
    <div class="container">
      <div class="row align-items-center" data-aos="fade-up">
        <div class="col-lg-6 col-12 order-lg-0 order-1 pr-lg-5">
          <img
            class="img-fluid aggregator-img"
            :src="this.publicPath+'assets/img/pngs/the-aggregator-branded.png'"
            alt="the ear aggregator branded"
            title="the ear aggregator branded"
          />
        </div>
        <div class="col-lg-6 col-12">
          <div class="row">
            <div class="col-12">
              <h3 class="title text-normal">
                Aggregator <span class="font-bold">Branded</span>
              </h3>
            </div>
            <div class="col-12">
              <span class="sub-text center mb-lg-0 mb-5"
                >Is a <b>B2B solution</b>, designed for providers that want to
                expand into an aggregation business vertical without the
                overhead.<br />The Ear provides a White Label aggregator
                complete Real-time invocing tool, easy to manage client area,
                and all aggregator bonus features, plus over
                <strong>13,000 games</strong> with reselling option in multiple
                markets.<br /><strong>The Ear Aggregator Branded</strong>
                solution takes away the day-to-day overhead of the third-party
                Game Providers and technology management, leaving you room to
                focus on client acquisition.</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "casinoAggregatorSection",
  components: {},

  data() {
    return {
      publicPath:process.env.VUE_APP_PUBLIC_PATH ?? "/",
      lang: localStorage.getItem("language") ?? "en",
    };
  },
  computed: {},
  mounted() {},
  created() {
    document.body.style.fontFamily = "Poppins, sans-serif";
  },
  methods: {},
};
</script>

<style scoped>
.section {
  padding: 60px 15px 0px 15px;
}

.section-bro-card {
  padding: 85px 15px 0px 15px !important;
}

.aggregator-branded-container {
  padding-top: 100px;
}

.section .title {
  text-align: center;
  font-weight: 700;
  font-size: 25px;
  line-height: 1.44;
  color: #25354d;
  margin: 0px 0px 20px 0px;
  font-family: "Montserrat", sans-serif;
}
.section .card {
  text-align: center;
  background: transparent;
  border: 0;
  transition: all 0.4s ease;
}
.section .card .card-img-top {
  transition: all 0.4s ease;
  max-width: 250px;
}
.section .card a {
  color: inherit;
}
.section .card .card-body {
  border: 1px solid transparent;
  margin-top: 1rem;
  transition: all 0.4s ease;
  border-radius: 10px;
}
.section .card .card-body .card-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.section .card:hover .card-body {
  color: #1976d2;
}

.section.desc-1 .title {
  text-align: center;
  font-weight: 700;
  font-size: 25px;
  line-height: 1.44;
  margin-bottom: 15px;
  color: #25354d;
  font-family: "Montserrat", sans-serif;
}
.section.desc-1 .sub-text {
  text-align: center;
  line-height: 1.75;
  font-size: 17px;
  margin-top: 20px !important;
  font-weight: 500;
  font-family: "Montserrat", sans-serif;
}
.section.desc-1 .vacancy-cnt {
  color: white;
}
.section.desc-1 .vacancy-cnt .title {
  color: #2196f3;
  transition: all 0.4s ease;
}
.section.desc-1 .vacancy-cnt:hover .title {
  color: #ff5722;
}
.section.desc-1 .multiple-items {
  justify-content: left;
}
.section.desc-1 .multiple-items .col-card {
  flex: 0 0 25%;
  margin-bottom: 1.5rem;
}

.bro-card:hover {
  border-color: #ff5722 !important;
  color: #fff;
  background: #ff5722 !important;
}

@media (max-width: 992px) {
  .section.desc-1 .multiple-items .col-card {
    flex: 0 0 33.3%;
  }
  .aggregator-img {
    padding-top: 40px;
    padding-bottom: 40px;
  }

  .aggregator-branded-container {
    padding-top: 60px;
  }

  .genie-img {
    padding-top: 65px;
  }
}

@media (max-width: 768px) {
  .aggregator-img {
    padding-top: 40px;
    padding-bottom: 40px;
  }

  .aggregator-branded-container {
    padding-top: 60px;
  }

  .genie-img {
    padding-top: 35px;
  }
}

@media (max-width: 576px) {
  .section.desc-1 .multiple-items .col-card {
    flex: 0 0 50%;
  }
}
.section.desc-1 .multiple-items .col-card .bro-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 300px;
  height: 70px;
  background: #e66640;
  color: #fff;
  padding: 1rem 1rem;
  text-transform: uppercase;
  font-weight: bold;
  text-align: center;
  box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.25);
  transition: all 0.4s ease;
  border: 2px solid transparent;
  border-radius: 999px;
  font-size: 0.8rem;
  text-transform: uppercase;
  margin: 0;
}
.section.desc-1 .multiple-items .col-card .bro-card .img-fluid {
  max-height: 55px;
}
.section.desc-1 .multiple-items .col-card .bro-card-orange {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 300px;
  height: 70px;
  background: #e66640;
  color: #fff;
  padding: 1rem 1rem;
  text-transform: uppercase;
  font-weight: bold;
  text-align: center;
  box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.25);
  transition: all 0.4s ease;
  border: 2px solid transparent;
  border-radius: 999px;
  font-family: "Montserrat", sans-serif;
}

.img-fluid {
  max-width: 100%;
  height: auto;
}
</style>
